import React from 'react';

import { SVGComponentProps } from './svg.types';

const BookOpenSVG = ({
  fill = 'currentColor',
  size = '14',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block align-middle ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M7 2.91698C4.666 0.583985 2.333 0.583984 0 0.583984V11.084C2.334 11.084 4.667 11.084 7 13.417C9.334 11.084 11.667 11.084 14 11.084V0.583984C11.666 0.583984 9.333 0.583985 7 2.91698Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default BookOpenSVG;
